import React from 'react';
import { ISelectFieldProps, ISelectOption, Select } from '../../ui-toolkit/components';
import { getIn, useFormikContext } from 'formik';
import { ContactOptionsType, IConversationContactData } from '../../types/conversations/IConversationContact';
import { IConversationOrderData } from '../../types/conversations/IConversation';

interface IContactSelectFieldProps extends ISelectFieldProps {
  options: ContactOptionsType;
}

export const ContactSelectField: React.FC<IContactSelectFieldProps> = ({ options, name, ...rest }) => {
  const formik = useFormikContext<IConversationOrderData>();
  const onChange = (value: any) => {
    formik.setFieldTouched(name as never);
    formik.setFieldValue(name as never, value ? value.value : undefined);
  };

  const errorText =
    (!!formik.submitCount || !!getIn(formik.touched, name)) && !!getIn(formik.errors, name)
      ? getIn(formik.errors, name)
      : null;

  const contact = formik.values.contact;
  const value = options
    .find((group: any) => group.options.length && group.options[0].value.contactType === contact?.contactType)
    ?.options.find((option: ISelectOption<IConversationContactData>) => option.value.id === contact?.id);

  return <Select {...rest} options={options} onChange={onChange} errorText={errorText} value={value} />;
};
